import React from 'react';
import { useLoginContext } from '../../Contexts/LoginContext';
import { useLayoutContext } from '../../Contexts/LayoutContext';
import Button from '../Form/Button';
import { TbUserQuestion } from 'react-icons/tb';
import { useLoginHook } from '../../Hooks/LoginHook';
import { useStoreContext } from '../../Contexts/StoreContext';

interface ButtonLoginProps {
    className?: string;
    asButtonGray?: boolean;
    labelLink?: string;
    forceSsoLogin?: boolean;
    withLoading?: boolean;
}

const ButtonLogin = ({
    className,
    asButtonGray = false,
    labelLink,
    forceSsoLogin = false,
    withLoading = false

}: ButtonLoginProps) => {

    const { isAuthenticated, setShowLoginBasic } = useLoginContext();
    const { company } = useLayoutContext();
    const { handleRedirectSSO } = useLoginHook();
    const { currentStore } = useStoreContext();

    const handleClick = () => {
        if (forceSsoLogin) {
            handleRedirectSSO();
        } else {
            setShowLoginBasic(true);
        }
    }

    if (!company || isAuthenticated) return null;

    if (currentStore?.id === 54) return null; //! FIXADO PARA NÃO EXIBIR LOGIN NA ZZ

    return (
        <Button
            outline
            gray={asButtonGray}
            onClick={handleClick} 
            withLoading={withLoading}
            className={`
                ${className}
                relative justify-center items-center
                min-h-max
                flex gap-3
            `}
        >
            <span className="flex items-center gap-1 leading-none">
                <div><TbUserQuestion /></div>
                <div>{labelLink}</div>
            </span>
        </Button>
    )


}

export default ButtonLogin;